/**
 * @file コンポーネント：執刀医情報 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { ModalSurgeon } from "~/src/components/projects/ModalSurgeon";

// スタイル読み込み
import { StyledSurgeonAnchor, StyledSurgeonText } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <>
            {props.nolink ? (
                // リンク無し
                <StyledSurgeonText data-on-color={props.onColor}>
                    Dr. {props.name}
                </StyledSurgeonText>
            ) : (
                // リンク有り
                <StyledSurgeonAnchor
                    data-on-color={props.onColor}
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        props.setIsShow(true);
                    }}
                >
                    {props.name}
                </StyledSurgeonAnchor>
            )}
            {/* 執刀医モーダル */}
            <ModalSurgeon
                fnSetModalEdit={props.fnSetModalEdit}
                isEditPage={props.isEditPage}
                isShow={props.isShow}
                setIsShow={props.setIsShow}
                surgeonId={props.id}
            />
        </>
    );
};
